/**
 * Extract display content from message data
 * @param {object} data - Message data
 * @returns {string} Display content
 */
export const extractMessageContent = data => {
  if (typeof data.content === 'string') {
    return data.content;
  }
  if (typeof data.content === 'object' && data.content !== null) {
    return data.content.snowflake || data.content.text || data.content.message || JSON.stringify(data.content, null, 2);
  }
  return String(data.content || '');
};